// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"65":"newsDetail","424":"homePage","435":"sub","818":"auth"}[chunkId] + "." + {"65":"1725bcf3","424":"1e3fee07","435":"16879c0c","818":"73516328"}[chunkId] + ".css";
};